<template>
  <span @click="$emit('click')">
    <span v-if="icon" class="icon">
      <i class="mdi" :class="[icon]"></i>
    </span>
    <span> <slot></slot> </span>
  </span>
</template>

<script>
export default {
  props: { icon: String },
};
</script>
